import { useStore } from '@kundinos/nanostores/react';

import { sizeParameterStore } from './stores';

function useSizeParameter() {
  return useStore(sizeParameterStore);
}

export default useSizeParameter;
